var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1938 13.9999L21.5458 8.64805C22.1516 8.04224 22.1516 7.06019 21.5458 6.45439C20.9401 5.84858 19.958 5.8487 19.3522 6.45439L14.0002 11.8064L8.64805 6.45426C8.04224 5.84858 7.06019 5.84858 6.45439 6.45426C5.8487 7.06007 5.8487 8.04212 6.45439 8.64792L11.8064 13.9999L6.45426 19.352C5.84858 19.9579 5.84858 20.9399 6.45426 21.5458C6.75717 21.8486 7.15413 22 7.55109 22C7.94806 22 8.34502 21.8485 8.64792 21.5458L14 16.1936L19.3522 21.5458C19.6551 21.8485 20.052 22 20.449 22C20.846 22 21.2429 21.8485 21.5458 21.5458C22.1516 20.9399 22.1516 19.9579 21.5458 19.352L16.1938 13.9999Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.489a3bbda94a2d64ffdf42267d15205e.svg";
export { ForwardRef as ReactComponent };